import {
  Component,
  ViewEncapsulation,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AnalyticsService,
  CustomerService,
  StorageService
} from '../../../_services/index';
import {
  DataService,
  OptionsserviceService,
  LoansService,
  OperationsService
} from '../../../_services/index';
import { IonRangeSliderComponent } from 'ng2-ion-range-slider';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-analyticssmslogs',
  templateUrl: './analyticssmslogs.component.html',
  styleUrls: ['./analyticssmslogs.component.css']
})
export class AnalyticssmslogsComponent implements OnInit {
  showPicture = false;
  title = 'SMS Analytics';
  @Input('details') details: any;
  phone_ownership: any;
  average_credit: any;
  average_income: any;
  salary_amount: any;
  token: any;
  sms_hightlights: any;
  @Input('parentRouteId') parentRouteId: any;
  loan: any;
  selected_analytics = '1';
  nodesandscores: any;
  analytics_result: any;
  sub: any;
  currentUser: any;
  data: any;
  view: any = 'data';
  nodes_and_scores: any;
  analytics_last_done = '';
  sms_value: any;
  guarantor_value: any;
  call_logs_value: any;
  cards_value: any;
  profile_value: any;
  social_value: any;
  accounts_value: any;
  dd_value: any;
  repayment_value: any;
  lender_id: any;
  borrower_id: any;
  principal: any;
  maturity_date: any;
  account_card_id: any;
  loan_request_id: any;
  card_id: any;
  passed_analytics: any;
  failed_analytics: any;
  number_passed: number;
  number_failed: number;
  analytics_score: number;
  meta_data: any;
  last_twenty_sms_crd_arr: any[];
  last_twenty_sms_deb_arr: any[];
  last_twenty_sms_sal_arr: any[];
  last_twenty_sms_loan_cr_arr: any[];
  last_twenty_sms_loan_rep_arr: any[];
  last_twenty_sms_airtime_arr: any[];
  last_twenty_sms_loan_def_arr: any[];
  last_twenty_sms_other_exp_arr: any[];
  risk_related_sms: any[];
  sms_analytics: any;
  params: any = JSON.parse(localStorage.getItem('params'));
  sms_status: any;
  bvn_value: any;
  loading: boolean;
  compared_data: any;
  expense_category: any;
  debit_arr: any[];
  credits_arr: any[];
  debit_and_credit_arr: any[];
  customer_name: string;
  throttle = 300;
  scrollDistance = 1;
  scrollUpDistance = 2;
  direction = '';
  public doughnutChartLabels: string[] = ['', '', '', '', ''];
  public doughnutChartData: number[] = [10, 10, 10];
  public doughnutChartLegend: any = { 'display': false, 'position': 'bottom' };
  public doughnutChartType: string = 'doughnut';
  public doughnutChartOptions: any = {
    legend: {
      display: false,
      position: 'right'
    },
    percentageInnerCutout: 10,
    borderWidth: 5
  };
  constructor(
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public dataService: DataService,
    private _location: Location,
    public router: Router,
    private analyticsService: AnalyticsService,
    private http: HttpClient
  ) {
    this.currentUser = this.storageService.read<any>('currentUser');
    //this.sms_value = this.params.sms;
  }

  dataView() {
    this.view = 'data';
  }

  analyticsView() {
    this.view = 'analytics';
  }
  ngOnInit() {
    // this.dataService.emitAnalytics.subscribe(res => {
    //   //console.log(res);
    //   this.passed_analytics = res.sms_analytics.passed;
    //   this.failed_analytics = res.sms_analytics.failed;
    //   //console.log(this.passed_analytics);
    // });
    this.getAnalyticsData();
    //this.getAnalytics();
  }
  getAnalyticsData() {
    this.loading = true;
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'];
      this.loansService
        .getSMSAnalyticsData(this.currentUser.token, this.parentRouteId)
        .subscribe(data => {
          this.loading = false;
          this.dataService.onRequestLoadingEndFromBackend.emit({loan:data.loan});
          this.customer_name = data.loan.customer.legal_name;
        this.analytics_last_done = data.loan.analytics_summary.last_done;
        this.sms_analytics = data.loan.analytics_summary.description.sms_;
        this.number_passed = data.loan.analytics_summary.counts.sms_passed;
          this.number_failed = data.loan.analytics_summary.counts.sms_failed;
        this.analytics_score = data.loan.analytics_summary.sms * 100;
        this.meta_data = data.loan.analytics_summary.output.sms.data.meta_info;
        this.last_twenty_sms_crd_arr =
          data.loan.analytics_summary.output.sms.data.sms_data.credit.last_twenty_sms;
        this.last_twenty_sms_deb_arr =
          data.loan.analytics_summary.output.sms.data.sms_data.debit.last_twenty_sms;
        this.last_twenty_sms_sal_arr =
          data.loan.analytics_summary.output.sms.data.sms_data.salary.last_twenty_sms;
        this.last_twenty_sms_loan_cr_arr =
          data.loan.analytics_summary.output.sms.data.sms_data.loan_credit.last_twenty_sms;
        this.last_twenty_sms_loan_rep_arr =
          data.loan.analytics_summary.output.sms.data.sms_data.loan_repayment.last_twenty_sms;
        this.last_twenty_sms_loan_def_arr =
          data.loan.analytics_summary.output.sms.data.sms_data.loan_default.last_twenty_sms;
        this.last_twenty_sms_airtime_arr =
          data.loan.analytics_summary.output.sms.data.sms_data.airtime.last_twenty_sms;
        this.last_twenty_sms_other_exp_arr =
          data.loan.analytics_summary.output.sms.data.sms_data.other_expenses.last_twenty_sms;
        this.risk_related_sms = data.loan.analytics_summary.sms_analysis.risk_sms;
        this.sms_status = data.loan.analytics_summary.status.sms;
        this.sms_hightlights = data.loan.analytics_summary.sms_highlights;
        this.expense_category = data.loan.analytics_summary.sms_analysis.expense_distribution;
        this.doughnutChartData = data.loan.analytics_summary.doughnut_amount;
        this.doughnutChartLabels = data.loan.analytics_summary.doughnut_labels;
        this.debit_arr = data.loan.analytics_summary.sms_analysis.debits;
        this.credits_arr = data.loan.analytics_summary.sms_analysis.credits;
        this.debit_and_credit_arr = this.debit_arr.concat(this.credits_arr);
        });
    });
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({
      section: section,
      request_id: this.parentRouteId
    });
  }
  saveAnalytics(event) {
    this.loansService
      .saveSMSAnalysisData(
        this.currentUser.token,
        this.parentRouteId,
        this.nodes_and_scores,
        this.data
      )
      .subscribe(data => {
        this.data = data.result;
        this.details = data.result;
        this.nodes_and_scores = data.nodes_and_scores;
        this.analytics_last_done = data.analytics_last_done;
        this.loan = data.loan;
      });
  }
  modifyAnalytics(event) {
    this.dataService.onEditApplicationsModal.emit({
      section: 'specific_analytics',
      request_id: this.parentRouteId,
      nodes_and_scores: this.nodes_and_scores,
      selected_analytics: '1',
      analytics_last_done: this.analytics_last_done,
      isedit: '1'
    });
  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }
  doingDisbursement(event) {}
  // modifyAnalyticsResult() {
  //   this.modifyAnalytics.emit();
  // }
  goBack() {
    this._location.back();
  }
  getAnalytics() {
    return new Promise((resolve, reject) => {
      return this.http
        .post<any>(`https://eligibilitytest.creditclan.com/public/requestparams`, {
          request_id: '13126'
        })
        .toPromise()
        .then(res => {
          //console.log(res);
          this.lender_id = res.lender_id;
          this.borrower_id = res.borrower_id;
          this.principal = res.principal;
          this.maturity_date = res.maturity_date;
          this.account_card_id = res.account_card_id;
          this.loan_request_id = res.loan_request_id;
          this.card_id = res.card_id;
          resolve();
        })
        .then(() => this.getFullAnalytics())
        .catch(err => {
          //console.log(err);
          // reject();
        });
    });
  }
  getFullAnalytics() {
    //console.log(this.lender_id);
    return this.analyticsService
      .getFullAnalytics(
        this.lender_id,
        this.borrower_id,
        this.principal,
        this.maturity_date,
        this.account_card_id,
        this.loan_request_id,
        this.card_id,
        this.sms_value,
        this.call_logs_value,
        this.profile_value,
        this.guarantor_value,
        this.cards_value,
        this.accounts_value,
        this.dd_value,
        this.repayment_value,
        this.social_value,
        {}
      )
      .subscribe(data => {
        this.passed_analytics = data.description.sms.passed;
        this.failed_analytics = data.description.sms.failed;
        this.number_passed = this.passed_analytics.length;
        this.number_failed = this.failed_analytics.length;
        this.analytics_score = data.sms * 100;
        this.meta_data = data.output.sms.data.meta_info;
        this.last_twenty_sms_crd_arr =
          data.output.sms.data.sms_data.credit.last_twenty_sms;
        this.last_twenty_sms_deb_arr =
          data.output.sms.data.sms_data.debit.last_twenty_sms;
        this.last_twenty_sms_sal_arr =
          data.output.sms.data.sms_data.salary.last_twenty_sms;
        this.last_twenty_sms_loan_cr_arr =
          data.output.sms.data.sms_data.loan_credit.last_twenty_sms;
        this.last_twenty_sms_loan_rep_arr =
          data.output.sms.data.sms_data.loan_repayment.last_twenty_sms;
        this.last_twenty_sms_loan_def_arr =
          data.output.sms.data.sms_data.loan_default.last_twenty_sms;
        this.last_twenty_sms_airtime_arr =
          data.output.sms.data.sms_data.airtime.last_twenty_sms;
        this.last_twenty_sms_other_exp_arr =
          data.output.sms.data.sms_data.other_expenses.last_twenty_sms;
        this.sms_status = data.status.sms;
        this.sms_hightlights = data.sms_highlights;
      });
  }
  onScrollDown() {
    console.log('scrolled down')
  }
}
